module.exports = __webpack_public_path__ + "6dc39f4d05cbbe83e8ed2c14da45b4f6.MP3";